import {useState, useMemo, useEffect} from 'react';
import Select from 'react-select';
import ApiSoftland from '../../services/apis.softland.service';


const SelectIvaSoftland = ({id, value, onChange, isInvalid,filter, isClearable,disabled,tipoDoc,isMulti,finalCorpo}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        ApiSoftland.getIva().then((response) => {
            setItems(response);
        });
    }, []);

    useEffect(() => {
        if(items?.length > 0){
            const newOptions = items?.map((item) => ({ value: item.cod_iva, label: item.nombre} ));
            if(filter){
                let filtro = newOptions.filter(iv => iv.value === 'C' || iv.value === 'E' || iv.value === 'I' || iv.value === 'M' )
                if(tipoDoc === '80'){
                    filtro = newOptions.filter(iv => iv.value === 'E' || iv.value === 'I' || iv.value === 'M' )
                    if(finalCorpo){
                        filtro = newOptions.filter(iv => iv.value === 'C' || iv.value === 'E' || iv.value === 'I' || iv.value === 'M' )
                    }
                }
                setOptions(filtro);
            }else{
                setOptions(newOptions);
            }
            if(typeof value === 'string' || typeof value === 'number'){
                setSelectedValue(
                    newOptions.find((opt) => opt.value === value)
                );
            }else if(Array.isArray(value)){
                setSelectedValue(value.map(va=>{
                    const item = items.find(it=>it.cod_iva === va);
                    if(item){
                        return {
                            value:item.cod_iva,
                            label:item.nombre
                        };
                    }
                    return null
                }))
            }
        }
    }, [items,value,tipoDoc]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectIvaSoftland.defaultProps = {
    isClearable: false
};

export default SelectIvaSoftland;
